import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrMoonIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M7.17699 3.55645C6.79303 4.23684 6.57457 4.99873 6.54374 5.77885C6.5068 6.6841 6.71635 7.61475 7.20291 8.45851C7.68958 9.30245 8.38663 9.94423 9.19322 10.3633C9.8848 10.7294 10.6569 10.9225 11.4413 10.9294C11.3291 11.0648 11.2111 11.1895 11.084 11.3062C10.849 11.5164 10.5796 11.7069 10.2605 11.8922C9.18264 12.5159 7.95678 12.6449 6.84584 12.346C5.74059 12.05 4.75056 11.3409 4.13146 10.2869C4.12442 10.2712 4.11654 10.2557 4.10785 10.2407C3.48407 9.16281 3.35499 7.93682 3.65394 6.82575C3.94999 5.72047 4.65909 4.73046 5.71303 4.11136C5.72929 4.10408 5.7452 4.09592 5.76068 4.08689C6.06055 3.91199 6.36398 3.77762 6.67153 3.67804C6.84004 3.6274 7.00794 3.58692 7.17699 3.55645ZM8.0551 2.63551C7.87732 2.51139 7.68437 2.49092 7.53917 2.50302L7.5807 3.00129L7.54235 2.50276C7.14498 2.53332 6.76045 2.60673 6.37818 2.72202L6.36903 2.72488C6.00619 2.84194 5.64967 2.99816 5.29995 3.19819C5.2844 3.20511 5.26918 3.21284 5.25434 3.22136C3.9367 3.97776 3.05318 5.20388 2.68807 6.56674C2.32632 7.91147 2.47779 9.39361 3.21763 10.6985C3.22472 10.7146 3.23267 10.7303 3.24146 10.7456C3.99781 12.0631 5.22382 12.9466 6.58656 13.3118C7.94621 13.6777 9.44635 13.5188 10.7617 12.7576C11.1284 12.5447 11.4573 12.3144 11.7534 12.0491L11.7576 12.0453C12.0564 11.7714 12.3083 11.4692 12.5371 11.132C12.5406 11.1268 12.544 11.1215 12.5474 11.1162C12.7674 10.7641 12.6842 10.2928 12.3311 10.0474C12.3221 10.0411 12.3129 10.0351 12.3034 10.0295C12.1666 9.9472 11.9957 9.89985 11.8195 9.91549C11.0668 9.9792 10.3157 9.82643 9.65952 9.47872L9.65577 9.47675C9.01171 9.14242 8.45745 8.63224 8.0692 7.95896C7.68054 7.28498 7.51336 6.54262 7.54292 5.81933C7.57233 5.07385 7.81771 4.34559 8.25098 3.72523C8.49975 3.36764 8.40512 2.87941 8.0551 2.63551Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrMoonIconComponent;
